<template>
    <div class="home_box">
        <div class="top_box">
            <div class="name_box">
                <div class="name_cont">
                    <img class="logo" src="../../static/img/nameIcon.png" alt="" srcset="" />
                    <div class="names">英思普网关调度平台</div>
                </div>
                <div class="btn_box">
                    <el-dropdown>
                        <span class="el-dropdown-link">
                            <el-avatar size="small"
                                src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="backBtn" v-if="user_type == '1'">返回导航</el-dropdown-item>
                            <el-dropdown-item @click.native="pwdBtn">修改密码</el-dropdown-item>
                            <el-dropdown-item style="color: #f56c6c" @click.native="outBtn">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>

        <div class="main_box">
            <div class="menu_box">
                <Menulist></Menulist>
            </div>
            <div class="cont_box">
                <div class="tabs_box">
                    <Tablist></Tablist>
                </div>
                <div class="main_box">
                    <transition name="fade" mode="out-in">
                        <keep-alive :include="cachedViews">
                            <router-view></router-view>
                        </keep-alive>
                    </transition>
                </div>
            </div>
        </div>
        <!-- 修改密码 -->
        <Setpwd ref="pwdRef"></Setpwd>
    </div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {
            user_type: this.$cookie.get("userType"),
        };
    },
    components: {
        Menulist: () => import("@/components/common/menulist"),
        Tablist: () => import("@/components/common/tablist"),
        Setpwd: () => import("@/components/common/setpwd"),
    },
    computed: {
        // keepAlive缓存name
        cachedViews() {
            return this.$store.state.tabsNav.tabsValue.map((item) => item.name);
        },
    },
    mounted() { },
    methods: {
        // 返回导航
        backBtn() {
            this.$router.push("/nav");
        },
        // 修改密码
        pwdBtn() {
            this.$refs.pwdRef.pwdSet()
        },
        // 退出登录
        outBtn() {
            this.$confirm("此操作将退出登录, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$router.push("/login");
                    this.$message({
                        type: "success",
                        message: "退出成功!",
                    });
                    this.$cookies.remove("token");
                    this.$cookies.remove("menuNum");
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消退出",
                    });
                });
        },
    },
};
</script>
<style lang='less' scoped>
.home_box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .top_box {
        width: 100%;
        height: 3.3rem;
        background: #152a3d;

        .name_box {
            width: 100%;
            height: 100%;
            background: url("../assets/images/home2/top_bg.png") center center no-repeat;
            background-size: 100% 100%;
            box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.07);
            padding: 0 1rem;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            z-index: 999;

            .name_cont {
                width: 30rem;
                height: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                .logo {
                    width: 3.5rem;
                    height: 1.65rem;
                    margin-right: 1rem;
                    margin-left: 1rem;
                }

                .names {
                    font-family: YouSheBiaoTiHei;
                    font-size: 1.4rem;
                    color: #ffffff;
                }
            }

            .btn_box {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .el-dropdown-link {
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
    }

    .main_box {
        width: 100%;
        height: calc(100% - 3.3rem);
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .menu_box {
            width: 12rem;
            height: 100%;
            background: #0f1f30;
        }

        .cont_box {
            width: calc(100% - 12rem);
            height: 100%;
            background: #152a3d;

            .tabs_box {
                width: 100%;
                height: 2rem;
            }

            .main_box {
                width: 100%;
                height: calc(100% - 2rem);

                background: #152a3d !important;
            }
        }
    }
}

// 页面动画
.fade-enter-active {
    transition: all 1s;
    transition-delay: 0s;
}

.fade-leave-active {
    transition: all 0.5s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>